module.exports = __webpack_public_path__ + "static/home-hero.73cdd899.webm";


//////////////////
// WEBPACK FOOTER
// ./src/static/videos/home-hero.webm
// module id = 946
// module chunks = 35783957827783